import UpdateResultsController from '@/delonghi/Controllers/Listing/UpdateResultsController';
import LazyLoadInfiniteResultsController from '@/braun/Controllers/Listing/LazyLoadInfiniteResultsController';
import ListingBackToPlpController from '@/braun/Controllers/Listing/ListingBackToPlpController';
import { checkWishlistIcon } from '@/delonghi/Controllers/DELWishlistController';
import { updateProductsPositionForGTMListing } from '@/utils/Controllers/GTM/Utils';

export const rebindAll = () => {
  LazyLoadInfiniteResultsController();
  checkWishlistIcon();
};

export default () => {
  UpdateResultsController();
  ListingBackToPlpController();
  LazyLoadInfiniteResultsController();
  updateProductsPositionForGTMListing();
};
